export default "__VITE_ASSET__B_k1XqnE__"